import { Directive, Input } from '@angular/core';
import { Observable, of } from 'rxjs';
import { InputCheckersService } from '../Services/input-checkers.service';
import { map } from 'rxjs/operators';
import { AbstractControl, AsyncValidator, NG_ASYNC_VALIDATORS, ValidationErrors } from '@angular/forms';
import { InseeEtablissement } from '../all-models';


@Directive({
  selector: '[siretActif]',
  providers: [{
    provide: NG_ASYNC_VALIDATORS, useExisting: SiretActifDirective, multi:
      true
  }]
})
export class SiretActifDirective  implements AsyncValidator {

  constructor(
    private inputCheckersSvc: InputCheckersService) { }
  private msg:string;

@Input() supplierId?:number;


  validate(control: AbstractControl): Promise<ValidationErrors> | Observable<ValidationErrors> {
    const siret=(<string>control.value || '').replace(/\s/g, '');
    if ((control.value||'null')=='null') return of(null);
    
    let getEtbsFn:Observable<InseeEtablissement> = this.inputCheckersSvc.getInseeEtablissement(siret);
    if (this.supplierId){
      getEtbsFn = this.inputCheckersSvc.getSupplierInseeEtablissement(this.supplierId,siret);
    }


    return getEtbsFn
      .pipe(map((inseeEtab:InseeEtablissement)=> {
        if (!inseeEtab) return null; //Mettre la directive SiretValidator pour afficher le message Siret_Inexistant
        if (inseeEtab.isClosed) {
          return {'SiretActif':'Msg_SIRET_Etablissement_Inactif'};
        } else {
          return null;
        }
      }));
  }


  registerOnValidatorChange?(fn: () => void): void {
    
  }
}
